<template >
  <sc-panel-navigator
      :drawerWidth="400" >
    <ctk-dater
        range
        v-model="bookingRange"
        display-format="dd/MM/yyyy"
        export-format="DD/MM/YYYY"
        valueFormat="onurl"
        default="2months"

    ></ctk-dater >
    <el-divider ></el-divider >
    <el-input
        placeholder="SQL constrains"
        v-model="constrains" ></el-input >
    <el-divider ></el-divider >
    <q-space />
    <el-radio-group
        v-model="pivotctx"
        style="width: 100%" >
      <el-radio-button label="Transfers" ></el-radio-button >
      <el-radio-button label="Trips" ></el-radio-button >
      <el-radio-button label="bookings_excrs" >Excrs.Bookings</el-radio-button >
      <el-radio-button label="emails" >Emails</el-radio-button >
    </el-radio-group >
    <!-- <el-container> -->

    <!-- <s-dater range v-model="filters.daterange" displayFormat="dd/MM/yyyy"></s-dater> -->

    <el-radio-group
        v-model="filterctx"
        style="width: 100%" >
      <el-radio-button label="auto" >Auto</el-radio-button >
      <el-radio-button label="range:invoice_date" >Date By Invoice</el-radio-button >
      <el-radio-button label="range:ScheduledTrip.time" >Date By Excursions</el-radio-button >

    </el-radio-group >

    <!--    <el-row >-->
    <!--      <sf-button-->
    <!--          @click="downloadExcel()"-->
    <!--          type="success"-->
    <!--          style="float: right"-->
    <!--          fit-->
    <!--          material="cloud_download"-->
    <!--      >-->
    <!--        Full excursions ticket report-->
    <!--      </sf-button >-->
    <!--    </el-row >-->
    <!--    <pre>{{predifinedConfigurations}}</pre>-->
    <el-row
        v-for="(scrpt, idx) in predifinedConfigurations"
        :key="idx" >
      <el-col :span="22" >
        <sf-button
            fit
            :material="scrpt.query.execute=='download'?'cloud_download':'search'"
            @click="routeGo({ query: scrpt.query })"
            style="float: right;width:100%" >
          {{ scrpt.title }}
        </sf-button >
      </el-col >

      <el-col :span="2" >

        <sf-button
            confirm="Do you want to delete this analysis?"
            type="danger"
            material="delete"
            :title="scrpt.title"
            @click="deleteSetting(scrpt.title,'logistics');predifinedConfigurations.splice(idx-1,1);" ></sf-button >
      </el-col >
    </el-row >
    <el-row >
      <el-collapse-transition >
        <el-button
            @click="goSave=true"
            v-if="!goSave"
            key="1" >
          Keep This Analysis
        </el-button >
        <el-card
            v-else
            key="2" >
          <div
              slot="header"
              class="clearfix" >
            <el-input v-model="configKeyToSet" ></el-input >
            <el-radio
                v-model="configurationExecution"
                label="search" >View
            </el-radio >
            <el-radio
                v-model="configurationExecution"
                label="download" >Download
            </el-radio >
            <el-button
                @click="prepareAndSave" >
              Keep This Analysis
            </el-button >
          </div >
        </el-card >
      </el-collapse-transition >
    </el-row >
    <!--    <pre>-->
    <!--      {{ $route.query }}-->
    <!--    </pre>-->
  </sc-panel-navigator >
</template >

<script >
import {mapMutations, mapGetters, mapActions} from "vuex";
import _ from "lodash";
import * as dateHelper from "date-fns";
import * as api from "~/api/resource";
import commons from "~/mixins/commons";

import printHtml from "~/mixins/printHtml";
import SfButton from "../../Form/SfButton";

export default {
  components: {SfButton},
  mixins: [printHtml,
           commons],
  data() {
    return {

      goSave: false,
      configurationExecution: 'search',
      configKeyToSet: null,
      predifinedConfigurations: [
        {
          title: "Invoices for trip bookings",
          query: {
            colby: "TourCompany,AA",
            pivotctx: "bookings_excrs",
            rowby: "Trip_Date",
            pivotrender: false,
            execute: "download"
          }
        },
        {
          title: "Invoices for EXCRS by date/company",
          query: {
            colby: "Trip_Date,Inv_Type,TourCompany",
            pivotctx: "bookings_excrs",
            rowby: "AA",
            group_all_aggragators: true,
            pivotrender: false,
            execute: "download"
          }
        }
      ],
      filters: {daterange: null},
      loaded: false,
      leftWidth: "280px",
      reloadClock: 0
    };
  },
  watch: {
    filters: {
      handler(val) {
        _log_("n....", val);
        this.setStatFilters(val);
      },
      deep: true
    }
  },
  computed: {
    constrains: {
      get() {
        return this.$route.query.constrains ? this.$route.query.constrains : null;
      },
      set(v) {
        this.routeGo({query: {constrains: v}});
      }
    },
    pivotctx: {
      get() {
        return this.$route.query.pivotctx ? this.$route.query.pivotctx : null;
      },
      set(v) {
        this.routeGo({query: {pivotctx: v}});
      }
    },
    filterctx: {
      get() {
        return this.$route.query.filterctx ? this.$route.query.filterctx : null;
      },
      set(v) {
        this.routeGo({query: {filterctx: v}});
      }
    }
  },
  methods: {
    prepareAndSave() {
      let configurationToSave = JSON.parse(JSON.stringify(this.$route.query))
      configurationToSave.execute = this.configurationExecution
      delete configurationToSave.timerange_from
      delete configurationToSave.timerange_to
      configurationToSave = JSON.stringify(configurationToSave)
      this.setSetting(this.configKeyToSet, configurationToSave, 'logistics');
      this.goSave = false;
      this.predifinedConfigurations.push({title: this.configKeyToSet, query: this.$route.query})
      // this.configurationToSave = JSON.stringify(this.$route.query);
    },
    downloadExcel() {

      api.ajax_download("vue_booking/getlist", {
        range: [
          this.$route.query.timerange_from,
          this.$route.query.timerange_to
        ],
        tripTypes: this.pivotctx == "Transfers" ? "ARV,DEP" : "EXCRS",
        groupby:
            this.pivotctx == "Transfers"
                ? "ScheduledTrip.flight,Timologio.aa"
                : "ScheduledTrip.id,Timologio.aa,TourCompany.id,Rep.id",
        type: "full",
        sort: "ScheduledTrip.time",
        limit: 0,
        download: 1
      });
    },

    ...mapMutations({setStatFilters: "user/setStatFilters"}),


    alert(msg) {
      _log_("hell...", msg, this.bookingRangeA.getTime());
    }
  },
  async mounted() {
    const date = new Date(),
        vm = this

    const data = await this.getSetting(null, 'logistics')
    if (data) {
      data.forEach(e => {
        this.predifinedConfigurations.push({title: e.key, query: e.setting})
      })
      // this.predifinedConfigurations=[...this.predifinedConfigurations,...data]
    }
    // await this.fetchAllOptions();
    // var { data } = await api.fetchProcessor("bookings/vuebookings", {
    //   "bookingRange[]": this.bookingRange,
    //   idHotel: this.activeHotel,
    //   searchall: this.searchall,
    //   dailyView: true,
    //   limit: 0
    // });
    // this.todayDepartures = data.results.departures
    //   ? data.results.departures
    //   : [];
    // this.todayArrivals = data.results.arrivals ? data.results.arrivals : [];
    this.loaded = true;
    // $(".panel_btn").unbind();
    // $(".panel_btn").attr("onclick", "");
    // $(".panel_btn").click(function () {
    //   if (vm.leftWidth == "280px") vm.leftWidth = "0px";
    //   else vm.leftWidth = "280px";
    //   // _log_("vvvv,", app, vm.$refs);
    // });
  }
};
</script >

<style >
.search.x-row {
  align-items: flex-start;
}

.has-more {
  color: red;
  font-weight: 700;
}

.flip-list-move {
  transition: transform 1s;
}
</style >
